module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', {
    staticClass: "image-navigator__menu",
    attrs: {
      "default-active": "0"
    }
  }, _vm._l((_vm.availableImages), function(availableImage, index) {
    return _c('el-menu-item', {
      key: availableImage.name,
      attrs: {
        "index": index + ''
      },
      on: {
        "click": function($event) {
          _vm.selectImage(availableImage)
        }
      }
    }, [_c('img', {
      staticClass: "image-navigator__thumbnail",
      attrs: {
        "src": _vm.thumbnails[availableImage.name]
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(availableImage.name))])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1cf0cc90","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/image-filter/image-navigator/image-navigator.vue
// module id = 282
// module chunks = 0